import { BLACK_PEARL, DIM_GREY, PALE_GRAY, PlACEBO_SKY } from 'constants/colors'

type Style = {
  [key: string]: string
}

// added customstyles as using css selectors would mean duplicating the styles in main.scss
export const customStyles = {
  dropdownIndicator: (provided): Style[] => ({
    ...provided,
    padding: 0,
  }),
  valueContainer: (provided): Style[] => ({
    ...provided,
    padding: '2px 2px',
    minWidth: 29,
  }),
  singleValue: (provided): Style[] => ({
    ...provided,
    color: BLACK_PEARL,
  }),
  indicatorSeparator: (provided): Style[] => ({
    ...provided,
    display: 'none',
  }),
  control: (provided, { menuIsOpen }): Style[] => ({
    ...provided,
    flexWrap: 'nowrap',
    border: `1px solid ${DIM_GREY}`,
    padding: '10px 22px',
    borderRadius: 10,
    outline: 'unset',
    borderBottomRightRadius: menuIsOpen ? 0 : 10,
    borderBottomLeftRadius: menuIsOpen ? 0 : 10,
    borderBottom: menuIsOpen ? `1px solid ${PALE_GRAY}` : null,
    boxShadow: 'unset',

    ':hover': {
      borderColor: DIM_GREY,
      borderBottomColor: menuIsOpen ? PALE_GRAY : null,
    },
  }),
  menuList: (provided): Style[] => ({
    ...provided,
    padding: 'unset',
    border: `1px solid ${DIM_GREY}`,
    borderTop: 'unset',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  }),
  option: (provided): Style[] => ({
    ...provided,
    backgroundColor: 'unset',
    color: BLACK_PEARL,
    padding: '12px 27px',
    ':hover': {
      cursor: 'pointer',
      backgroundColor: PlACEBO_SKY,
    },
    ':last-child': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
  }),
  menu: (styles): Style[] => ({
    ...styles,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    marginTop: 'unset',
  }),
}
